import React from 'react'
import { I18n } from '@front/volcanion'

import { TableCell } from '@mui/material'
import TextHeader from '@abra/elements/table/headers/Text'

const Header = () => <>
  <TableCell align='center'><TextHeader label={I18n.t('name.label', { count: 1 })} /></TableCell>
  <TableCell align='center'><TextHeader label={I18n.t('vehicletype.search_range')} /></TableCell>
  <TableCell align='center'><TextHeader label={I18n.t('vehicletype.approach_time')} /></TableCell>
</>

export default React.memo(Header)
